import { DKON_THEME } from './DKON'
import { TTDK_THEME } from './TTDK'
import { VIPMEMBER_THEME } from './VIPMEMBER'
import { TAMOVE_THEME } from './TAMOVE'
const themeName = process.env.REACT_APP_THEME_NAME
let themeIcons = TTDK_THEME
if (themeName == 'DKON') {
  themeIcons = DKON_THEME
} else if (themeName == 'VIPMEMBER') {
  themeIcons = VIPMEMBER_THEME
} else if (themeName == 'TAMOVE') {
  themeIcons = TAMOVE_THEME
} else {
  themeIcons = TTDK_THEME
}

export default themeIcons
